import { render, staticRenderFns } from "./deep.vue?vue&type=template&id=54f5c8de&scoped=true"
import script from "./deep.vue?vue&type=script&lang=js"
export * from "./deep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f5c8de",
  null
  
)

export default component.exports